module.exports = __webpack_public_path__ + "static/media/audio.283ab1e9.mp3";